'use client'

/* eslint-disable no-unneeded-ternary */
/* eslint-disable import/no-extraneous-dependencies */

import { styled, Box, $white, Flex } from '@acko-tech/building-blocks.ui.common'

export const ItemContainer = styled(Box)`
  background: ${$white};
  max-width: 1080px;
  margin: 0 auto;
`
export const ItemContentWrapper = styled(Box)`
  background: ${$white};
  @media screen and (min-width: 1140px) and (max-width: 1240px) {
    max-width: calc(100% - 40px);
  }

  @media screen and (min-width: 1140px) {
    width: 1170px;
    margin-left: auto;
    margin-right: auto;
  }
`

export const ItemContentContainer = styled(Flex).attrs(
    (props: { isMobile: boolean }) => props,
  )`
    flex-direction: column;
  
    @media screen and (min-width: 700px) {
      flex-direction: row;
    }
  
    ${({ isMobile }) =>
      isMobile &&
      `
    @media (max-width: 1370px) {
      flex-direction: column;
    }
  
    @media screen and (min-width: 700px) and (max-width: 1140px) {
      padding-left: 120px;
      padding-right: 120px;
    }
  
    `}
  `

  export const ItemLeftContainerWrapper = styled(Box).attrs(
    (props: { isMobile: boolean }) => props,
  )`
    padding-bottom: 20px;
    width: 100%;
    @media screen and (min-width: 700px) {
      width: 65%;
    }
  
    ${({ isMobile }) =>
      isMobile &&
      `
    @media (max-width: 1370px) {
      width : 100%;
    }
  
    `}
  `

  export const ItemRightContainerWrapper = styled(Box).attrs(
    (props: { isMobile: boolean }) => props,
  )`
    width: 100%;
    @media screen and (min-width: 700px) {
      max-width: 392px;
    }
  
    ${({ isMobile }) =>
      isMobile &&
      `
    @media (max-width: 1370px) {
      width : 100%;
    }
    `}
  `

export const ItemDivider = styled.hr`
  margin-top: 20px;
  margin-bottom: 20px;
`
